// src/routes/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * @param {Object} props
 * @param {boolean} props.isLoggedIn - whether user is logged in
 * @param {string[]} [props.userClaims] - array of user's claim names
 * @param {string[]} [props.requiredClaims] - array of claim names required for this route
 * @param {boolean} [props.allMustMatch] - if true => user needs ALL requiredClaims; else ANY is enough
 */
function ProtectedRoute({
                          children,
                          isLoggedIn,
                          userClaims = [],
                          requiredClaims = [],
                          allMustMatch = false
                        }) {
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (userClaims.includes('admin')) {
    return children;
  }

  if (requiredClaims.length === 0) {
    return children;
  }

  let hasRequired = false;
  if (allMustMatch) {
    hasRequired = requiredClaims.every((rc) => userClaims.includes(rc));
  } else {
    hasRequired = requiredClaims.some((rc) => userClaims.includes(rc));
  }

  if (!hasRequired) {
    return <div>You do not have the necessary permission(s) to view this page.</div>;
  }

  return children;
}

export default ProtectedRoute;
